import React from 'react'
import { Button } from 'reactstrap'
import IntlMessages from 'util/IntlMessages'

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="d-flex flex-row justify-content-between">
        <div>
          <span> Copyright <a href='https://lingoowl.com'>LingoOwl</a> &copy; 2019 – {new Date().getFullYear()}</span>

        </div>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./components/Footer/index.js